<div fxLayout="row" fxLayoutAlign="center center">
  <div fxFlex="100" [innerHTML]="diffHtml"></div>
</div>
